export default __webpack_public_path__ + "static/media/LouigGiano.1307b06d.jpg";